import axios from "axios";
import global from "./global";
import store from "@/store";
import { Message } from "view-design";
import { Toast } from "vant";
import "view-design/dist/styles/iview.css";
import SparkMD5 from "spark-md5";
import JSEncrypt from "jsencrypt";

/* 请求拦截器 */
axios.interceptors.request.use(
  async (config) => {
    // 获取公网Ip地址接口(借助三方接口) 环境上不需要加前缀
    var root = process.env.NODE_ENV === "development" ? "" : global.global.url;
    config.url = root + config.url;
    config.withCredentials = true;

    if (config.method == "get" && config.hasOwnProperty("params")) {
      // 处理ios端接口有缓存问题 参数加上一个时间戳
      config.params["timestamp"] = new Date().getTime();
    }

    /* ----------请求header处理----------- */
    if (process.env.NODE_ENV === "development")
      config.headers["zw-test"] = "zwjt801";

    if (!global.global.ispc) {
      config.headers["deviceType"] = config.headers["deviceType"]
        ? config.headers["deviceType"]
        : "H5";
      config.headers["deviceModel"] = "H5";
      config.headers["systemVersion"] = "H5";
      config.headers["appVersion"] = "H5";
      config.headers["mobileFlag"] = "H5";
    }

    const trip = sessionStorage.getItem("trip");
    if (trip) {
      var encryptStr = new JSEncrypt();
      encryptStr.setPublicKey(trip); // 设置 加密公钥
      const randomNum = Math.floor(10000000 + Math.random() * 90000000);
      const cnSign = randomNum + "zwjt8081!@#DF*F&^SKD" + new Date().getTime();
      const encryptCnSign = encryptStr.encrypt(cnSign); // 进行加密
      config.headers["cn-sign"] = encryptCnSign;
    }
    
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.common["token"] = token;
      let ip = sessionStorage.getItem("webIp");
      let timestamp = new Date().getTime();
      let nonce = ip + "-" + timestamp;

      let sign = token + nonce;
      let spark = new SparkMD5();
      spark.append(sign);
      let signMd5 = spark.end();
      config.headers["zw-nonce"] = nonce;
      config.headers["zw-sign"] = signMd5;
    }

    config.headers["Cache-Control"] = "no-cache";

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.resultCode === "1009") {
      if (sessionStorage.getItem("token")) {
        if (global.global.ispc) {
          Message.error("请重新登录");
        } else {
          Toast("请重新登录");
        }
        setTimeout(() => {
          store.commit("logOut");
        }, 500);
      }
    } else if (response.data.resultCode === "-1") {
      Message.error("服务器开小差了，请稍后重试");
    } else if (!response.data.resultCode === "200") {
      Message.error(response.data.resultDesc);
    }
    return response;
  },
  function (error) {
    if (
      error.response &&
      error.response.data.content.msg &&
      error.response.data.content.msg !== ""
    ) {
      Message.error(error.response.data.content.msg);
    } else if (
      error.response &&
      error.response.data.resultDesc &&
      error.response.data.resultDesc !== ""
    ) {
      Message.error(error.response.data.resultDesc);
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
